import { gql } from '@apollo/client';

export default gql`
  query getHotelBookings($bookingReference: String!) {
    getHotelBookings(bookingReference: $bookingReference) {
      bookingReference
      status
      totalPrice
      totalCommission
      arrivalDate
      numberOfGuests
      duration
    }
  }
`;
